var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toggle-button',{attrs:{"id":"changed-font","color":{checked: '#FB0', unchecked: '#000000'},"sync":true,"labels":{checked: 'YES', unchecked: 'NO'},"width":75,"height":35},on:{"change":function($event){_vm.$emit('change', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }